const React = require("react");
const {AdminTimeCell} = require("../../../../../TableTimeCell");
const {DisplayStatusChargeback} = require("../../../../../StatusDisplay");

const CHARGEBACK_DATA = [
  {
    title: 'Chargeback ID',
    dataKey: 'id'
  },
  {
    title: 'Date and time',
    dataHandler: ({created_at}) => <AdminTimeCell date={created_at} />
  },
  // {
  //   title: 'Fiat',
  //   dataHandler: ({payment_asset_amount, payment_asset_code}) => `${payment_asset_amount} ${payment_asset_code}`
  // },
  {
    title: 'Crypto',
    dataHandler: ({account_asset_amount, account_asset_code}) => `${account_asset_amount} ${account_asset_code}`
  },
  {
    title: 'Status',
    dataHandler: ({lifeflow: status}) => status
      ? (
        <DisplayStatusChargeback status={status} />
      ) : '-',
  }
];

module.exports = CHARGEBACK_DATA;
